export default {
  clube: {
    clientes_ativos_clube_help_text: '{porcentagemClientesAtivos} da base de {totalClientesCadastrados} clientes',
    clientes_ativos_clube: 'Clientes ativos no clube',
    gasto_medio_clube: 'Gasto médio por cliente do clube',
    gasto_medio_clube_help_text: 'Faturamento de vendas identificadas dividido pela quantidade de clientes ativos no período',
    media_cupons_clube: 'Média de cupons por cliente clube',
    media_itens_clube: 'Média de itens na cesta clube',
    novos_cadastros_clube: 'Novos cadastrados no clube',
    percentual_faturamento_clube: 'Percentual de faturamento no clube',
    ticket_medio_clube_help_text: 'R$ {faturamentoFidelidade} / {cuponsFidelidade} cupons',
    ticket_medio_clube: 'Ticket médio clube',
    ticket_medio_fora_clube_help_text: 'R$ {faturamentoFora} / {cuponsFora} cupons',
    ticket_medio_fora_clube: 'Ticket médio fora do clube',
    variacao_ticket_medio_help_text: 'Percentual de variação no ticket médio de clientes no clube em relação ao ticket médio de clientes fora do clube',
    variacao_ticket_medio: 'Diferença do ticket médio no clube',
  },
}
